import { CookieConsent, type ConsentLabels } from '@ventawiz/web-kit'
import { useTranslation } from 'react-i18next'

/**
 * The web kit's cookie banner and preferences dialog, in this app's words.
 *
 * Mounted once, in the root route. The kit owns the behaviour — the three
 * equal-weight choices, Global Privacy Control, renewal, and the `vw_consent`
 * cookie the other VentaWiz apps read too — and this supplies only the copy.
 */
export function CookieBanner() {
  const { t } = useTranslation()
  const labels: ConsentLabels = t('cookieConsent', { returnObjects: true })
  return <CookieConsent labels={labels} />
}
